import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { Subscription } from 'rxjs';

import { AppState } from '../../../../state';
import { selectSelectedLanguage } from '../../../state/study/study.selectors';
import { Study } from '../../../../models/study';
import { Module } from '../../../../models/module';
import { ModuleItem } from '../../../../models/module-item';
import { ModuleItemAvailableSubType, ModuleItemSubType } from '../../../../models/module-item-sub-type';
import { PrivilegeService } from '../../../services/privilege/privilege.service';
import { PRIVILEGE_ACTIONS, PRIVILEGE_SECTIONS, RANDOMIZATION_VALUES } from '../../../../core/dashboard-constants';
import { Language } from '../../../../models/language';
import { StudyType } from '../../../../models/study-type';
import { getModuleItemSubTypeLabel } from '../../helpers/module-item-helper';
import { ModuleItemsConfig } from '../../../../models/module-items-config';
import { selectModuleItemsConfig } from '../../../state/module-item/module-item.selectors';
import { ModuleItemAvailableType } from 'src/app/models/module-item-type';

const MODULE_ITEM_DIALOG_TAB_LABELS = {
  PREVIEW: 'PREVIEW',
  ROUTING: 'ROUTING',
};

@Component({
  selector: 'dashboard-module-item-dialog',
  templateUrl: './module-item-dialog.component.html',
  styleUrls: ['./module-item-dialog.component.scss'],
})
export class ModuleItemDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  availableModuleItems: ModuleItemSubType[] = [];
  selectedStudy: Study;
  selectedModule: Module;
  moduleItemSubType: ModuleItemSubType;
  selectedModuleItem: ModuleItem;
  selectedLanguage: Language;

  moduleItemsConfig: ModuleItemsConfig;

  MODULE_ITEM_DIALOG_TAB_LABELS = MODULE_ITEM_DIALOG_TAB_LABELS;
  PRIVILEGE_SECTIONS = PRIVILEGE_SECTIONS;
  PRIVILEGE_ACTIONS = PRIVILEGE_ACTIONS;
  RANDOMIZATION_VALUES = RANDOMIZATION_VALUES;
  ModuleItemAvailableSubType = ModuleItemAvailableSubType;
  ModuleItemAvailableType = ModuleItemAvailableType;

  StudyType = StudyType;

  getModuleItemSubTypeLabel = getModuleItemSubTypeLabel;

  type = '';
  subType = '';

  private subscriptions = new Subscription();

  constructor(
    private store: Store<AppState>,
    private changeDetectorRef: ChangeDetectorRef,
    public privilegeService: PrivilegeService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      availableModuleItems: ModuleItemSubType[];
      selectedStudy: Study;
      selectedModule: Module;
      moduleItem: ModuleItem;
      moduleItemSubType: ModuleItemSubType;
      isDuplicate: boolean;
    }
  ) {}

  ngOnInit(): void {
    this.availableModuleItems = this.data?.availableModuleItems;
    this.selectedStudy = this.data?.selectedStudy;
    this.selectedModule = this.data?.selectedModule;
    this.moduleItemSubType = this.data?.moduleItemSubType;
    this.selectedModuleItem = this.data?.moduleItem;

    if (this.selectedModuleItem) {
      this.setModuleItemSubTypeValue();
    }

    this.type = this.selectedModuleItem?.type || this.moduleItemSubType?.itemType;
    this.subType = this.selectedModuleItem?.subType || this.moduleItemSubType?.type;

    this.subscriptions.add(
      this.store
        .select(selectSelectedLanguage)
        .subscribe((selectedLanguage) => (this.selectedLanguage = selectedLanguage))
    );
    this.subscriptions.add(
      this.store
        .select(selectModuleItemsConfig)
        .subscribe((moduleItemsConfig) => (this.moduleItemsConfig = moduleItemsConfig))
    );
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  selectModuleItem(moduleItem: ModuleItemSubType): void {
    this.moduleItemSubType = moduleItem
    this.type = this.moduleItemSubType.itemType;
    this.subType = this.moduleItemSubType.type;
    this.data.moduleItemSubType = this.moduleItemSubType;
  }

  setModuleItemSubTypeValue(): void {
    this.moduleItemSubType = this.availableModuleItems.find(moduleItemSubType => this.selectedModuleItem.subType === moduleItemSubType.type);
  }
}
